import type { UnifiedProductSummary } from '@noths/polaris-client-unified-product-service';

import { transformUnifiedProductToProduct } from 'src/utils/unifiedProductToProduct';
import type { PartnerProduct } from './types';

/**
 * One of a partner's products is one card's props. The mapping from unified product
 * to OOUX product is shared with the product carousel, so both agree on what a
 * product means; only the card-level presentation is decided here.
 */
export const transformUnifiedProductToPartnerProduct = (
  product: UnifiedProductSummary,
  { priority, promoteAsSale }: { priority: boolean; promoteAsSale: boolean },
): PartnerProduct => ({
  isNew: product.isNew,
  priority,
  product: transformUnifiedProductToProduct(product),
  /* From the site-wide Contentstack switch, not `product.onSale`. Nothing UPS carries
     distinguishes a sale from an offer, so presenting a discount as either is a
     decision about the whole site rather than about this block or this product. */
  promoteAsSale,
});
